var React = require('react');

function Lightning (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.8"},React.createElement("path",{"d":"M7.08118 23.9999C6.70677 24.0096 6.41883 23.5361 6.55406 23.1221L9.79221 12.3968H5.55962C5.10886 12.413 4.82828 11.745 5.11806 11.3364L12.4416 0.251099C12.7912 -0.312083 13.5989 0.155974 13.4232 0.828333L11.7305 8.0924C12.0865 8.23941 16.9198 7.82432 16.9437 8.55181C17.0357 8.77449 17.0137 9.03933 16.8867 9.23714L7.52735 23.7393C7.41788 23.908 7.25137 23.9999 7.08118 23.9999ZM6.70309 11.0813C13.2852 11.0088 11.2181 10.2565 8.81433 19.5679L15.3283 9.47495C9.20254 9.23282 10.0765 10.65 11.6017 3.66694L6.70309 11.0813Z","fill":"white"})));
}

Lightning.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Lightning;

Lightning.default = Lightning;
